export default "__VITE_ASSET__RT2$rsYD__"